import { PostType } from 'src/constants/types';

export const getPostTypeName = (postTypeId: PostType): string => {
  switch (postTypeId) {
    case PostType.Reply: return 'reply';
    case PostType.Post:  return 'post';
    case PostType.Poll:  return 'poll';
    default: return 'post';
  }
};
